import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { DriverAdminTabs } from '../../components/admin/DriverAdminTabs';
import { ArrowLeft, Car, Loader2, CheckCircle2, AlertCircle, Hash, Palette, Tag } from 'lucide-react';
interface VehicleForm {
  plate: string;
  vehicle_type: string;
  brand: string;
  model: string;
  color: string;
  is_active: boolean;
}
export function CreateVehiclePage() {
  const navigate = useNavigate();
  const [form, setForm] = useState<VehicleForm>({
    plate: '',
    vehicle_type: 'moto',
    brand: '',
    model: '',
    color: '',
    is_active: true
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const updateField = (field: keyof VehicleForm, value: string | boolean) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    if (!form.plate.trim()) return setError('La placa es obligatoria.');
    setIsSubmitting(true);
    try {
      const {
        error: insertError
      } = await supabase.from('vehicles').insert({
        plate: form.plate.trim().toUpperCase(),
        vehicle_type: form.vehicle_type,
        brand: form.brand.trim() || null,
        model: form.model.trim() || null,
        color: form.color.trim() || null,
        is_active: form.is_active
      });
      if (insertError) throw insertError;
      setSuccess(true);
    } catch (err: any) {
      console.error('[CreateVehicle] Error:', err);
      setError(err.message || 'Error al registrar el vehículo.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (success) {
    return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans flex flex-col items-center justify-center p-6" data-id="element-3796" data-mp="39lnnxn9ok5lk">
        <div className="max-w-md w-full space-y-6 text-center" data-id="element-3797" data-mp="35ihl6pls0wju">
          <div className="w-20 h-20 bg-[#006847]/20 rounded-full flex items-center justify-center mx-auto" data-id="element-3798" data-mp="12x55iawgzui7">
            <CheckCircle2 className="w-10 h-10 text-[#00a870]" data-id="element-3799" data-mp="17q7yohxc51xv" />
          </div>
          <h1 className="text-2xl font-bold" data-id="element-3800" data-mp="ty9wkr21k6b7">¡Vehículo registrado!</h1>
          <p className="text-white/50" data-id="element-3801" data-mp="xykd2xngmf4b">
            El vehículo {form.plate.toUpperCase()} fue guardado exitosamente.
          </p>

          <div className="flex gap-3 pt-4" data-id="element-3802" data-mp="1lpptpf185bfo">
            <button onClick={() => {
            setSuccess(false);
            setForm({
              plate: '',
              vehicle_type: 'moto',
              brand: '',
              model: '',
              color: '',
              is_active: true
            });
          }} className="flex-1 py-3 bg-white/5 border border-white/10 rounded-xl font-bold text-white/70 hover:bg-white/10 transition-colors" data-id="element-3803" data-mp="1lmlk224zpnhm">
              Registrar otro
            </button>
            <button onClick={() => navigate('/admin/vehicles')} className="flex-1 py-3 bg-[#006847] rounded-xl font-bold text-white hover:bg-[#005a3d] transition-colors" data-id="element-3804" data-mp="3tv043ucagz6m">
              Ver vehículos
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans" data-id="element-3805" data-mp="2q9sxainet6t">
      <div className="max-w-lg mx-auto px-4 sm:px-6 py-8 space-y-6" data-id="element-3806" data-mp="3b4s6tsv9t2yc">
        <DriverAdminTabs data-id="element-3807" data-mp="366gxdj8w0ugn" />

        {/* Header */}
        <div className="flex items-center gap-4" data-id="element-3808" data-mp="367rw34nh7c0w">
          <button onClick={() => navigate('/admin/vehicles')} className="w-10 h-10 bg-[#141414] border border-white/10 rounded-xl flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-3809" data-mp="3kvd3hardvxem">
            <ArrowLeft className="w-5 h-5" data-id="element-3810" data-mp="2se0q268yea9x" />
          </button>
          <div data-id="element-3811" data-mp="2ng8wz8wkoi45">
            <h1 className="text-2xl font-bold" data-id="element-3812" data-mp="2ngh7iu583bc6">Nuevo Vehículo</h1>
            <p className="text-white/40 text-sm" data-id="element-3813" data-mp="2ne4tgs2l5l4e">
              Registra un vehículo en la plataforma
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-3814" data-mp="1voqgy5n9xx5m">
          {/* Plate */}
          <div data-id="element-3815" data-mp="1zp0lddvf4fid">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3816" data-mp="1zo7k2sf8ai7m">
              Placa (Requerido)
            </label>
            <div className="relative" data-id="element-3817" data-mp="29f2b0a3f65ze">
              <Hash className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/20" data-id="element-3818" data-mp="29e0n351b1p09" />
              <input type="text" value={form.plate} onChange={e => updateField('plate', e.target.value)} placeholder="ABC-123" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-12 pr-4 py-4 text-base text-white font-mono uppercase placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" required data-id="element-3819" data-mp="2ed3s4phabv88" />
            </div>
          </div>

          {/* Vehicle Type */}
          <div data-id="element-3820" data-mp="ljdxszy168n2">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3821" data-mp="lj5hsz6m2n7n">
              Tipo de Vehículo
            </label>
            <select value={form.vehicle_type} onChange={e => updateField('vehicle_type', e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] appearance-none" data-id="element-3822" data-mp="bsawpy53ptns">
              <option value="moto" data-id="element-3823" data-mp="vfgxlz5etv6u">🏍️ Moto</option>
              <option value="carro" data-id="element-3824" data-mp="vdxhq9no1m5l">🚗 Carro</option>
              <option value="bicicleta" data-id="element-3825" data-mp="qgnun0nr1mkx">🚲 Bicicleta</option>
              <option value="otro" data-id="element-3826" data-mp="qg4ffrphhcal">📦 Otro</option>
            </select>
          </div>

          {/* Brand & Model */}
          <div className="grid grid-cols-2 gap-4" data-id="element-3827" data-mp="3g3d66xzewys2">
            <div data-id="element-3828" data-mp="3b5lgmam8por1">
              <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3829" data-mp="3b51xiqkusubf">
                Marca
              </label>
              <div className="relative" data-id="element-3830" data-mp="3hmmuzbjqyoix">
                <Tag className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" data-id="element-3831" data-mp="3hmd3tkmyubbn" />
                <input type="text" value={form.brand} onChange={e => updateField('brand', e.target.value)} placeholder="Honda" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-10 pr-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3832" data-mp="33mc62e1zzk0e" />
              </div>
            </div>
            <div data-id="element-3833" data-mp="2oxfuw84n9qvk">
              <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3834" data-mp="2oyzby0y4k5ye">
                Modelo
              </label>
              <input type="text" value={form.model} onChange={e => updateField('model', e.target.value)} placeholder="Civic" className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3835" data-mp="2fxjd8qgo9sa0" />
            </div>
          </div>

          {/* Color */}
          <div data-id="element-3836" data-mp="21cx79ims7qd3">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-3837" data-mp="2falpeipgsjeg">
              Color
            </label>
            <div className="relative" data-id="element-3838" data-mp="2aahbn0fxy2rx">
              <Palette className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" data-id="element-3839" data-mp="2a9eg2f7obc5o" />
              <input type="text" value={form.color} onChange={e => updateField('color', e.target.value)} placeholder="Rojo" className="w-full bg-[#141414] border border-white/10 rounded-xl pl-10 pr-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3840" data-mp="2p2hsy9abl1q2" />
            </div>
          </div>

          {/* Active Toggle */}
          <div className="flex items-center justify-between bg-[#141414] border border-white/10 rounded-xl p-4" data-id="element-3841" data-mp="9a96c80wjwr1">
            <span className="text-sm font-medium text-white/70" data-id="element-3842" data-mp="d7x5jn9moboq">
              Vehículo activo
            </span>
            <button type="button" onClick={() => updateField('is_active', !form.is_active)} className={`w-14 h-8 rounded-full transition-colors relative ${form.is_active ? 'bg-[#006847]' : 'bg-white/10'}`} data-id="element-3843" data-mp="3ho7z70skv20b">
              <div className={`w-6 h-6 bg-white rounded-full absolute top-1 transition-transform ${form.is_active ? 'translate-x-7' : 'translate-x-1'}`} data-id="element-3844" data-mp="3qnbkmbf7vthz" />
            </button>
          </div>

          {/* Error */}
          {error && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-start gap-3 text-red-400" data-id="element-3845" data-mp="32y0h4m6hfl05">
              <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-3846" data-mp="2vf0zom2l03jf" />
              <div className="text-sm whitespace-pre-line" data-id="element-3847" data-mp="2qg6hnmcfuj0d">{error}</div>
            </div>}

          {/* Submit */}
          <button type="submit" disabled={isSubmitting} className="w-full py-5 bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-black text-lg rounded-xl transition-all flex items-center justify-center gap-2 active:scale-95" data-id="element-3848" data-mp="2lfs5pt7puox2">
            {isSubmitting ? <>
                <Loader2 className="w-6 h-6 animate-spin" data-id="element-3849" data-mp="22qc1auswucbd" />
                Guardando...
              </> : <>
                <Car className="w-6 h-6" data-id="element-3850" data-mp="1xtlp4ik880v8" />
                Registrar Vehículo
              </>}
          </button>
        </form>
      </div>
    </div>;
}